<script lang="ts">
  import { book, bookingConfirmation } from "../../stores/WalkinBookingStore";

  let localData: any = {};
  let selectedLocation: string = "";
  let selectedTimeslot: string = "";
  let formattedDate: string = "";
  let formattedTimeslot: string = "";
  let groupSize: string = "";
  let fullName: string = "";
  let email: string = "";
  let phone: string = "";

  let bookingReference: string = "";
  let bookingSecureToken: string = "";

  let todaysDate: string = new Date().toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
    weekday: "long",
  });

  const url = new URL(window.location.href);

  let customerFirstName: string = "";
  let customerLastName: string = "";
  let customerEmail: string = "";
  let customerLocation: string = "";

  let copySuccess: boolean = false;

  book.subscribe((value) => {
    localData = value;
    selectedLocation = value.locationName;
    selectedTimeslot = value.timeslot;
    fullName = value.customer.fullName;
    email = value.customer.email;
    phone = value.customer.phone;
    customerFirstName = value.customer.firstName;
    customerLastName = value.customer.lastName;
    customerEmail = value.customer.email;
    customerLocation = value.locationName;
  });

  bookingConfirmation.subscribe((value) => {
    bookingReference = value.reference;
    bookingSecureToken = value.secureToken;
  });

  $: bookingWalkinUrl =
    url.host === "badaxe.local.host"
      ? "http://localhost:8002"
      : "https://booking.badaxethrowing.com";

  // $: waiverLink = `${bookingWalkinUrl}?bi=${btoa(`book=social&source=video&first_name=${customerFirstName}&last_name=${customerLastName}&email=${customerEmail}&location=${customerLocation}`)}`;
  $: bookingWaiverLink = `${bookingWalkinUrl}?bi=${btoa(`book=social&bookRef=${bookingReference}`)}`;
  $: videoLink = `https://badaxethrowing.com/safety-video?bi=${btoa(`book=social&bookRef=${bookingReference}`)}`;

  const sendViaEmail = () => {
    const subject = encodeURIComponent(
      "Watch our Safety Video and Sign Your Waiver for Bad Axe Throwing",
    );
    const body = encodeURIComponent(
      `Hi,\n\nPlease watch our safety video and sign your waiver for your Bad Axe Throwing session at ${selectedLocation}.\n\nClick here to watch it: ${videoLink}\n\nSee you soon!`,
    );
    // window.location.href = `mailto:?subject=${subject}&body=${body}`;
    // const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
    // console.log("Opening email with link:", mailtoLink);
    // window.location.href = mailtoLink;
    const mailtoLink = `mailto:?subject=${subject}&body=${body}`;

    const anchor = document.createElement("a");
    anchor.href = mailtoLink;
    anchor.target = "_blank";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const sendViaSMS = () => {
    const message = encodeURIComponent(
      `Watch our safety video and sign your waiver for Bad Axe Throwing: ${videoLink}`,
    );
    window.open(`sms:?&body=${message}`, "_blank");
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(videoLink);
      copySuccess = true;
      setTimeout(() => {
        copySuccess = false;
      }, 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };
</script>

<div class={`flex flex-col justify-center items-center flex-wrap`}>
  <h3 class="text-center text-2xl font-semibold my-4">
    THANK YOU FOR WATCHING THE SAFETY VIDEO
  </h3>
  <p>
    <img
      src="/wp-content/themes/badaxe/img/walkins/green-approved.png"
      alt="Approved"
      class="mx-auto h-40 sm:h-40"
    />
  </p>
  <p class="text-center mt-2 mb-2">
    Next Step: Sign The Waiver. <span class="block">Click below.</span>
  </p>
  <p class="mt-4">
    <a
      href={bookingWaiverLink}
      class="px-4 py-2 bg-brand text-white text-center w-full block rounded-lg"
      >Sign Waiver</a
    >
  </p>
  <div class="mt-3 p-4 bg-gray-100 rounded-lg">
    <p class="text-sm text-center mb-3 font-semibold">
      Send the safety video link to others:
    </p>
    <div class="flex flex-col gap-2">
      <!-- <button
        on:click={sendViaEmail}
        class="flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
          ></path>
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
          ></path>
        </svg>
        Send via Email
      </button> -->

      <button
        on:click={sendViaSMS}
        class="flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
      >
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"
          ></path>
          <path
            d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"
          ></path>
        </svg>
        Send via SMS
      </button>

      <button
        on:click={copyToClipboard}
        class="flex items-center justify-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors relative"
      >
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"></path>
          <path
            d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
          ></path>
        </svg>
        {copySuccess ? "Copied!" : "Copy Link"}
      </button>
    </div>
  </div>
  <div class={`w-full lg:w-full mx-auto mt-4 mt-4`}>
    <p class="text-xl text-center">
      Here's the contact info we received from you:
    </p>
    <ul class="my-4">
      <li
        class="py-2 px-2 bg-gray-200 dark:bg-white text-black dark:text-black"
      >
        <!-- <b>Booking #: </b> <span>{bookRef}</span> -->
        <b>Booking #: </b> <span>{bookingReference}</span>
      </li>
      <li class="py-2 px-2">
        <b>Where: </b> <span>{selectedLocation}</span>
      </li>
      <li
        class="py-2 px-2 bg-gray-200 dark:bg-white text-black dark:text-black"
      >
        <b>Date: </b> <span>{todaysDate}</span>
      </li>
      <li class="py-2 px-2">
        <!-- <b>Name: </b> <span>{firstName} {lastName}</span> -->
        <b>Name: </b> <span>{fullName}</span>
      </li>
      <li
        class="py-2 px-2 bg-gray-200 dark:bg-white text-black dark:text-black"
      >
        <b>Email: </b> <span>{email}</span>
      </li>
      <li class="py-2 px-2">
        <b>Phone: </b> <span>{phone}</span>
      </li>
    </ul>
  </div>
  <!-- <div>
    <button
      class="px-8 pt-6 pb-4 bg-brand hover:bg-brand-dark text-white rounded-sm transition-colors duration-300 uppercase font-semibold"
      on:click={onStartBookingProcess}
    >
      Start planning your next experience now.
    </button>
  </div> -->
</div>
